export default __webpack_public_path__ + "static/media/WOO.cf68f205.svg";